import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "./context/StoreContext";
import { App } from "./App";
import "./scss/app.scss";

const appID = process.env.Module;
const docAppId = appID === "dev" ? "#appSearch" : "#app" + appID;

const RootHTML = () => {
  if (appID === "dev") {
    return (
      <BrowserRouter>
        <StoreProvider>
          <App loadModule={appID}/>
        </StoreProvider>
      </BrowserRouter>
    );
  } else {
    return (
      <StoreProvider>
        <App loadModule={appID}/>
      </StoreProvider>
    );
  }
};

render(<RootHTML />, document.querySelector(docAppId));
